import { DataModel, ID } from './data.model';
import { Observable } from 'rxjs';
import {
  BaseStore,
  EntityStoreActions,
  EntityStoreFactory,
} from './base-store';
import { ReducerManager, Store } from '@ngrx/store';

export class DataStore<Model extends DataModel>
  implements EntityStoreActions<Model>
{
  private store: BaseStore<Model>;

  constructor(
    dataName: string,
    protected injectedStore: Store,
    protected manager: ReducerManager,
  ) {
    this.store = EntityStoreFactory.create<Model>(
      dataName,
      injectedStore,
      manager,
    );
  }

  selectData(): Observable<Model[]> {
    return this.store.selectData();
  }

  selectActiveData(): Observable<Model[]> {
    return this.store.selectActiveData();
  }

  selectIsLoading(): Observable<boolean> {
    return this.store.selectIsLoading();
  }

  selectError(): Observable<any> {
    return this.store.selectError();
  }

  addActiveItemById(id: ID): void {
    this.store.addActiveItemById(id);
  }

  deselectItem(item: Model): void {
    this.store.deselectItemById(item.id);
  }

  deselectItemById(id: ID): void {
    this.store.deselectItemById(id);
  }

  deselectAll(): void {
    this.store.deselectAll();
  }

  toggleItemById(id: ID): void {
    this.store.toggleItemById(id);
  }

  setItems(items: Model[]): void {
    this.store.setItems(items);
  }

  setIsLoading(isLoading: boolean): void {
    this.store.setIsLoading(isLoading);
  }

  setError(err): void {
    this.store.setError(err);
  }

  removeItemById(id: ID): void {
    this.store.removeItemById(id);
  }

  addItem(item: Model): void {
    this.store.addItem(item);
  }

  updateItem(id: ID, item: Model): void {
    this.store.updateItem(id, item);
  }

  hasEntity(id: ID): boolean {
    return this.store.hasEntity(id);
  }

  selectEntity(id: ID): Observable<Model> {
    return this.store.selectEntity(id);
  }

  setActiveItems(selectedIds: ID[]): void {
    this.store.setActiveItems(selectedIds);
  }

  clearData(): void {
    this.store.clearData();
  }

  /**
   * get ids of items, marked as selected
   *
   * @returns array of ids of selected items
   */
  getSelectedIds(): Observable<ID[]> {
    return this.store.getSelectedIds();
  }

  getAllItems(): Observable<Model[]> {
    return this.store.getAllItems();
  }
}
